import React from 'react'

const Header = ({ reportType, sort, sortOrder, onSortChange }) => {
    if (reportType == 'summary') {
        return (
            <thead>
                <tr className="revenue-list revenue-list--header">
                    <th style={{ width: '100px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('market')}>
                        Marketplace&#160;
                        {sort === 'market' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th style={{ width: '200px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('dmpProductId')}>
                        Product&#160;
                        {sort === 'dmpProductId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th className="revenue-list revenue-list--revenue pointer" onClick={() => onSortChange('impressions')}>
                        Impressions&#160;
                        {sort === 'impressions' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    
                    <th className="revenue-list revenue-list--revenue pointer" style={{ textAlign: 'right' }} onClick={() => onSortChange('revenue_gross')}>
                        Gross Revenue&#160;
                        {sort === 'revenue_gross' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th className="revenue-list revenue-list--revenue pointer" style={{ textAlign: 'right' }} onClick={() => onSortChange('revenue_net')}>
                        Net Revenue&#160;
                        {sort === 'revenue_net' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                </tr>
            </thead>
        )
    } else {
        return (
            <thead>
                <tr className="revenue-list revenue-list--header">
                    <th className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('licenseId')}>
                        License&#160;
                        {sort === 'licenseId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th style={{ width: '100px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('market')}>
                        Marketplace&#160;
                        {sort === 'market' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th style={{ width: '200px' }} className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('dmpProductId')}>
                        Product&#160;
                        {sort === 'dmpProductId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    {/*
                    <th className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('audienceName')}>
                        Audience&#160;
                        {sort === 'audienceName' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    */}
                    <th className="revenue-list revenue-list--property pointer" onClick={() => onSortChange('licensee')}>
                        Licensee&#160;
                        {sort === 'licensee' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th className="revenue-list revenue-list--revenue pointer" onClick={() => onSortChange('impressions')}>
                        Impressions&#160;
                        {sort === 'impressions' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th className="revenue-list revenue-list--revenue pointer" onClick={() => onSortChange('clicks')}>
                        Clicks&#160;
                        {sort === 'clicks' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th className="revenue-list revenue-list--revenue pointer" style={{ textAlign: 'right' }} onClick={() => onSortChange('revenue_gross')}>
                        Gross Revenue&#160;
                        {sort === 'revenue_gross' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                    <th className="revenue-list revenue-list--revenue pointer" style={{ textAlign: 'right' }} onClick={() => onSortChange('revenue_net')}>
                        Net Revenue&#160;
                        {sort === 'revenue_net' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
                    </th>
                </tr>
            </thead>
        )
    }

    return <thead />
}

export default Header
